export const GOOGLE_MAPS_API_KEY= "AIzaSyAWeQHJ_qwUfXm4fSsPw-MKUxvqtNR4FHI";
export const paymentUrl= "https://ecg.test.upc.ua/rbbh/enter";
export const paymentJSUrl= "https://ecconnect.upc.ua/pub/utils/upc-payment-sdk/upc-payment.js";
export const paymentCSSUrl= "https://ecconnect.upc.ua/pub/utils/upc-payment-sdk/upc-payment.css";
export const merchantID= "1757916";
export const terminalID = "E7885766";
export const versionPayment = 1;
export const paymentFee = 100;
export const paymentLocale = "en";